import { AssetCategory } from './types';

/** Accent color per asset category — used for the colored bar on asset
 *  rows and echoed on tasks linked to an asset (bar / dot) so a task
 *  visually inherits its placement's category. */
export const CATEGORY_COLOR: Record<AssetCategory, string> = {
  Email: 'var(--sitewide)',
  'Social Media': 'var(--brand)',
  Homepage: 'var(--seasonal)',
  Catalog: 'var(--accent-3, #E8A33E)',
  Promotion: 'var(--accent-5, #C94B9A)',
};
